import { defineLocalStore } from '@/utils/localStore'
import { computed, ref } from 'vue'
import type { NotificationSettingItem } from '@/utils/types/user'
import {
  userNotificationSettingsGet,
  userNotificationSettingsUpdate,
} from '@/requests/user'

const mapNotificationSettings = (items: any[] = []) =>
  items.map(item => ({
    eventKey: item.eventKey,
    title: item.label,
    description: item.description,
    inApp: item.channelSystem,
    email: item.channelEmail,
    telegram: item.channelTelegram,
  }))

export const {
  useLocalStore: useUserCardNotificationsStore,
  initLocalStore: initUserCardNotificationsStore,
} = defineLocalStore('userCardNotifications', (core: any) => {
  const notificationSettings = ref<NotificationSettingItem[]>([])
  const originalNotificationSettings = ref('')

  const loadNotificationSettings = (userId?: number | string) => {
    if (!userId) {
      notificationSettings.value = []
      originalNotificationSettings.value = ''

      return Promise.resolve()
    }

    return userNotificationSettingsGet(Number(userId)).then(res => {
      notificationSettings.value = mapNotificationSettings(res)
      originalNotificationSettings.value = JSON.stringify(
        notificationSettings.value
      )
    })
  }

  const saveNotificationSettings = () => {
    if (!core.user.id) {
      return Promise.resolve()
    }

    const settings = notificationSettings.value.map((item: any) => ({
      eventKey: item.eventKey,
      channelSystem: item.inApp,
      channelEmail: item.email,
      channelTelegram: item.telegram,
    }))

    return userNotificationSettingsUpdate(core.user.id, settings).then(res => {
      notificationSettings.value = mapNotificationSettings(res)
      originalNotificationSettings.value = JSON.stringify(
        notificationSettings.value
      )
    })
  }

  const hasNotificationSettingsChanges = computed(() => {
    return (
      JSON.stringify(notificationSettings.value) !==
      originalNotificationSettings.value
    )
  })

  return {
    hasNotificationSettingsChanges,
    loadNotificationSettings,
    notificationSettings,
    saveNotificationSettings,
  }
})
